import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: event =>
      createEventFunc({
        ...payload,
        path: `_hook.${hookId}`,
        slots: () => [
          {
            slot: "name",
            is: "strong",
            message: _.get(event, "object.name")
          }
        ]
      })(event)
  }
});

export default {
  ...createEventMap(HookCodes.BRAND_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.BRAND_UPDATED),
  ...createEventMap(HookCodes.BRAND_DELETED)
};
